var ListeProjets = {
	
	isMoving:false,
	mouseX:0,
	mouseY:0,
	currentRoll:null,
	timeoutRoll:0,
	
	init:function(){
		
		$(window).resize(function(){
			ListeProjets.resize();
		});
		ListeProjets.resize();
		
		if(Config.isTouchDevice()){
			$(".rollover-container").addClass("mobile");
		}
	
		$(".tease-projet").find(".img").mousemove(function(event){            
			ListeProjets.mouseX = event.pageX - $(this).offset().left;
			ListeProjets.mouseY = event.pageY - $(this).offset().top;
		});
		
		
		$(".tease-projet").find(".img").mouseenter(function(){
			ListeProjets.currentRoll = $(this).parent().find(".rollover-container");
			
			clearInterval(ListeProjets.timeoutRoll);
			
			ListeProjets.timeoutRoll = setTimeout(function(){
				ListeProjets.currentRoll.addClass("visible");
			}, 40);
			
			ListeProjets.isMoving = true;
			ListeProjets.moveRollover();
			
		}).mouseleave(function(){
			$(this).parent().find(".rollover-container").removeClass("visible");
			ListeProjets.isMoving = false;
		});

	},
	moveRollover:function(){

		ListeProjets.currentRoll.css({left:ListeProjets.mouseX, top:ListeProjets.mouseY});

		if(ListeProjets.isMoving == true){
			setTimeout(function(){
				ListeProjets.moveRollover();
			}, 40);
		}
	},
	resize:function(){

		var _slides_to_show = 1;
		var els = document.querySelectorAll(".list-projets-container");

		Array.prototype.forEach.call(els, function(el) {
			_slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));
		});

		$(".list-projets .slider").each(function(){
			ListeProjets.delete_carousel($(this));
			ListeProjets.create_carousel($(this), _slides_to_show);
		});
	},
	create_carousel:function(pTarget, pSlides){
				
		pTarget.slick({
			arrows:true, 
			dots:false,
			infinite: false,
			variableWidth:true,
			slidesToShow: pSlides,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow:pTarget.parent().find(".arrow-container .arrow-prev"),
			nextArrow:pTarget.parent().find(".arrow-container .arrow-next"),
		});	
	},
	delete_carousel:function(pTarget){
		if (pTarget.hasClass('slick-initialized')) {
			pTarget.slick('unslick');
		}

	}
}

$(window).load(function(){
	if($(".tease-projet").length){
		ListeProjets.init();
	}
	if($(".grid-projects-container").length){
		$('.grid-projects-container').infiniteScroll({
			path: '.next',
			append: '.tease-projet--list',
			hideNav: '.pagination-block',
			button: '.btn-voir-plus',
			scrollThreshold: true,
		});
	}

});